var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResourcesApiIcon = function SvgResourcesApiIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 84,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFFFFD",
    strokeLinejoin: "bevel",
    strokeWidth: 20,
    d: "m4.333 19 90.257-9L4.333 49 94.59 74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#44B58F",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "m40.327 55.533-6.72-6.72 6.72-6.72M58.223 55.533l6.72-6.72-6.72-6.72M44.807 55.533l8.936-13.44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#44B58F",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M73.903 17.477H24.67V66.71h49.233z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#44B58F",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M73.903 30.917H24.67v-13.44h49.233zM31.367 24.197h4.48M40.327 24.197h4.48M49.287 24.197h4.456"
  })));
};
export default SvgResourcesApiIcon;